import { gql } from '@apollo/client'

export const VERSION_REQUIREMENT_TRANSLATIONS = {
  close: 'common.dialog.button.close',
  content: 'versionRequirementDialog.content',
  reload: 'versionRequirementDialog.button.reload',
  title: 'versionRequirementDialog.title',
  update: 'versionRequirementDialog.button.update',
}

export const versionRequirementQuery = gql`
  query versionRequirement($versionNumber: String) {
    versionRequirement(buildVersionNumber: $versionNumber) {
      recommendedVersion
      requiredVersion
    }
  }
`

export const lastRecommendedVersionLocalStorageKey = 'lastRecommendedVersion'
